import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Table — primitive très simple. Pour des cas avancés, voir DataTable.
 */

export function Table({ className, children, ...rest }) {
  return (
    <div className="overflow-x-auto border border-border rounded-lg bg-surface">
      <table className={cn('w-full text-sm border-collapse', className)} {...rest}>
        {children}
      </table>
    </div>
  );
}

function Thead({ className, children }) {
  return (
    <thead className={cn('bg-bg-2/60 border-b border-border', className)}>
      {children}
    </thead>
  );
}

function Th({ className, children, ...rest }) {
  return (
    <th
      scope="col"
      className={cn('text-left px-3 py-2.5 text-[11px] uppercase tracking-wider font-semibold text-mute', className)}
      {...rest}
    >
      {children}
    </th>
  );
}

function Tbody({ className, children }) {
  return <tbody className={cn('divide-y divide-border', className)}>{children}</tbody>;
}

function Tr({ className, isClickable, children, ...rest }) {
  return (
    <tr
      className={cn(
        'transition-colors',
        isClickable ? 'hover:bg-bg-2 cursor-pointer' : 'hover:bg-bg-2/50',
        className,
      )}
      {...rest}
    >
      {children}
    </tr>
  );
}

function Td({ className, children, ...rest }) {
  return <td className={cn('px-3 py-3 align-middle', className)} {...rest}>{children}</td>;
}

function Tfoot({ className, children }) {
  return <tfoot className={cn('bg-bg-2/40 border-t border-border', className)}>{children}</tfoot>;
}

Table.Head = Thead;
Table.Th   = Th;
Table.Body = Tbody;
Table.Row  = Tr;
Table.Cell = Td;
Table.Foot = Tfoot;

export default Table;
